import { forwardRef, memo } from 'react';
import cx from 'classnames';
import { renderDesignTokens, useDesignTokens } from '../../theme';
import { SVG } from '../SVG';
import cn from './Icon.css.json';
import './Icon.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const Icon = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Icon(props, ref) {
  const dt = useDesignTokens();
  const tokens = {
    ...getIconDesignTokens(dt, {
      disabled: props.disabled,
      tokens: props.tokens,
      color: props.color
    }),
    ...props.theme?.(dt)
  };
  return /*#__PURE__*/_jsx(SVG, {
    id: props.id,
    ref: ref,
    style: {
      ...tokens,
      ...props.style
    },
    icon: props.icon,
    className: cx(cn.icon, props.className),
    testId: props.testId,
    type: "icon",
    role: props.role,
    onClick: e => {
      if (props.disabled) {
        e.stopPropagation();
        return;
      }
      props.onClick?.(e);
      props.onPress?.();
    },
    onKeyDown: e => {
      if (props.disabled) return;
      if (e.key === ' ' || e.key === 'Enter') {
        props.onPress?.();
      }
    },
    onDoubleClick: e => {
      if (props.disabled) return;
      props.onDoubleClick?.(e);
    },
    ariaHidden: props.ariaHidden,
    tabIndex: props.tabIndex ?? (props.onPress ? 0 : undefined),
    ariaLabel: props.ariaLabel,
    tooltip: props.tooltip
  });
}));
export const getIconDesignTokens = (dt, opts) => {
  let dtFg = opts?.tokens ? opts?.tokens().fg : undefined;
  const overrideTokens = opts?.tokens?.();
  if (opts?.color) {
    switch (opts?.color) {
      case 'primary':
        dtFg = dt.tokens['color-icon-primary'];
        break;
      case 'secondary':
        dtFg = dt.tokens['color-icon-secondary'];
        break;
      case 'alert':
        dtFg = dt.tokens['color-status-icon-alert'];
        break;
      case 'warning':
        dtFg = dt.tokens['color-status-icon-warning'];
        break;
      case 'success':
        dtFg = dt.tokens['color-status-icon-success'];
        break;
      case 'informational':
        dtFg = dt.tokens['color-status-icon-info'];
        break;
      case 'neutral':
        dtFg = dt.tokens['color-status-icon-neutral'];
        break;
      default:
        dtFg = undefined;
    }
  }
  let defaultFg = {
    'default-override-fg': undefined,
    'neutral-override-fg': undefined,
    'alert-override-fg': undefined,
    'warning-override-fg': undefined,
    'success-override-fg': undefined,
    'information-override-fg': undefined
  };
  if (opts?.disabled) {
    defaultFg = {
      'default-override-fg': dt.tokens['color-action-icon-standard-disabled'],
      'neutral-override-fg': dt.tokens['color-action-icon-standard-disabled'],
      'alert-override-fg': dt.tokens['color-action-icon-standard-disabled'],
      'warning-override-fg': dt.tokens['color-action-icon-standard-disabled'],
      'success-override-fg': dt.tokens['color-action-icon-standard-disabled'],
      'information-override-fg': dt.tokens['color-action-icon-standard-disabled']
    };
  }
  return {
    ...renderDesignTokens({
      'default-override-fg': dtFg ?? overrideTokens?.['default-fg'] ?? overrideTokens?.fg ?? defaultFg['default-override-fg'],
      'neutral-override-fg': dtFg ?? overrideTokens?.['neutral-fg'] ?? overrideTokens?.fg ?? defaultFg['neutral-override-fg'],
      'alert-override-fg': dtFg ?? overrideTokens?.['alert-fg'] ?? overrideTokens?.fg ?? defaultFg['alert-override-fg'],
      'warning-override-fg': dtFg ?? overrideTokens?.['warning-fg'] ?? overrideTokens?.fg ?? defaultFg['warning-override-fg'],
      'success-override-fg': dtFg ?? overrideTokens?.['success-fg'] ?? overrideTokens?.fg ?? defaultFg['success-override-fg'],
      'information-override-fg': dtFg ?? overrideTokens?.['information-fg'] ?? overrideTokens?.fg ?? defaultFg['information-override-fg']
    }, 'icon'),
    ...(!dt.enableNovaTokens && getIconLegacyDesignTokens(dt, opts))
  };
};
export const getIconLegacyDesignTokens = (dt, opts) => {
  let dtFg = opts?.tokens ? opts?.tokens().fg : undefined;
  const overrideTokens = opts?.tokens?.();
  if (opts?.color) {
    switch (opts?.color) {
      case 'primary':
        dtFg = dt.c.primary;
        break;
      case 'secondary':
        dtFg = dt.c.secondary;
        break;
      case 'alert':
        dtFg = dt.reportTokens.stateStatusContent.alert.fg;
        break;
      case 'warning':
        dtFg = dt.reportTokens.stateStatusContent.warning.fg;
        break;
      case 'success':
        dtFg = dt.reportTokens.stateStatusContent.success.fg;
        break;
      case 'informational':
        dtFg = dt.reportTokens.stateStatusContent.informational.fg;
        break;
      case 'neutral':
        dtFg = dt.c.neutral;
        break;
      default:
        dtFg = undefined;
    }
  }
  let defaultFg = {
    'default-override-fg': undefined,
    'neutral-override-fg': undefined,
    'alert-override-fg': undefined,
    'warning-override-fg': undefined,
    'success-override-fg': undefined,
    'information-override-fg': undefined
  };
  if (opts?.disabled) {
    defaultFg = {
      'default-override-fg': dt.reportTokens.stateStandard.disabled.fg,
      'neutral-override-fg': dt.reportTokens.stateStandard.disabled.fg,
      'alert-override-fg': dt.reportTokens.stateStandard.disabled.fg,
      'warning-override-fg': dt.reportTokens.stateStandard.disabled.fg,
      'success-override-fg': dt.reportTokens.stateStandard.disabled.fg,
      'information-override-fg': dt.reportTokens.stateStandard.disabled.fg
    };
  }
  return renderDesignTokens({
    'default-override-fg': dtFg ?? overrideTokens?.['default-fg'] ?? overrideTokens?.fg ?? defaultFg['default-override-fg'],
    'neutral-override-fg': dtFg ?? overrideTokens?.['neutral-fg'] ?? overrideTokens?.fg ?? defaultFg['neutral-override-fg'],
    'alert-override-fg': dtFg ?? overrideTokens?.['alert-fg'] ?? overrideTokens?.fg ?? defaultFg['alert-override-fg'],
    'warning-override-fg': dtFg ?? overrideTokens?.['warning-fg'] ?? overrideTokens?.fg ?? defaultFg['warning-override-fg'],
    'success-override-fg': dtFg ?? overrideTokens?.['success-fg'] ?? overrideTokens?.fg ?? defaultFg['success-override-fg'],
    'information-override-fg': dtFg ?? overrideTokens?.['information-fg'] ?? overrideTokens?.fg ?? defaultFg['information-override-fg']
  }, 'icon');
};
//# sourceMappingURL=Icon.js.map